import React from 'react'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import CompanySettings from "../Companies/CompanySettings";
import UpdateMintroute from './UpdateMintroute';
import translate from "../../../i18n/translate";
import { connect } from 'react-redux';

const MintRoutContainer = ({ isDarktheme }) => {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }
    return (

        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab className={!isDarktheme ? "" : "text-light"} label={translate("MintRout Settings")}  {...a11yProps(0)} />
                    <Tab className={!isDarktheme ? "" : "text-light"} label={translate("Update MintRout")} {...a11yProps(1)} />
                    <Tab className={!isDarktheme ? "" : "text-light"} label={translate("freeFire")} {...a11yProps(1)} />

                </Tabs>
            </Box>

            {value === 0 && <CompanySettings companyId="MintRoute" />}
            {value === 1 && <UpdateMintroute />}
            {value === 2 && <CompanySettings companyId="Freefire" />}
        </Box>
    )
}

const mapStateToProps = ({ companies: { companiesSettings }, darkTheme: { isDarktheme } }) => ({
    companiesSettings,
    isDarktheme

});
export default connect(mapStateToProps, null)(MintRoutContainer)